var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M14,26A12,12,0,1,0,2,14,12,12,0,0,0,14,26ZM18.243,9.757a1.2,1.2,0,0,1,0,1.7L15.7,14l2.546,2.546a1.2,1.2,0,1,1-1.7,1.7L14,15.7l-2.546,2.546a1.2,1.2,0,1,1-1.7-1.7L12.3,14,9.757,11.454a1.2,1.2,0,0,1,1.7-1.7L14,12.3l2.546-2.546A1.2,1.2,0,0,1,18.243,9.757Z",
    transform: "translate(-2 -2)",
    fill: "#e02020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.a989ec58ac2d5f164dae6210e36fed93.svg";
export { ForwardRef as ReactComponent };